<template>
  <div class="labelled" :class="{ disabled: disabled }">
    <span @click="isExpanded = !isExpanded">
      <span class="title">
        <b-icon v-if="icon" :icon="icon" />
        {{ title }}
      </span>
      <slot> </slot>
    </span>
    <div v-if="hasHelp">
      <div style="text-align: right">
        <b-icon v-if="isHelpExpanded" icon="remove" @click="isHelpExpanded = !isHelpExpanded" />
        <b-icon v-if="!isHelpExpanded" icon="plus" @click="isHelpExpanded = !isHelpExpanded" />
      </div>
      <transition name="list">
        <slot v-if="isHelpExpanded" name="helptext"> </slot>
      </transition>
    </div>
    <slot v-if="isExpanded" name="expand"> </slot>
  </div>
</template>

<script>
export default {
  name: 'BLabelled',
  data: function () {
    return {
      isExpanded: !!this.expanded,
      isHelpExpanded: !!this.helpExpanded,
    };
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    helpicon: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    expanded: {
      type: Boolean,
      default: false,
    },
    helpExpanded: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasHelp: function () {
      return !!this.$slots['helptext'];
    },
  },
  watch: {
    expanded: function () {
      this.isExpanded = this.expanded;
    },
  },
};
</script>

<style scoped>
.labelled {
  cursor: pointer;
}
.labelled input {
  border: 0px;
}
.disabled {
  text-decoration: line-through;
}
.title {
  margin-top: 10px;
  font-size: 80%;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/toolbar/BLabelled.vue